<template>
  <datatable :type="'companies'" :rowData="companies" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
      :paginationSize="50"></datatable>
</template>
<script>
import datatable from 'datatables/datatable';

export default {
  name: 'all_lapsed_clients',
  components: {
    datatable
  },
  data() {
    return {
      companies: null,
      loadingMessage: 'Loading Lapsed Clients...',
      noRowsMessage: 'No Lapsed Clients Found',
      columns: []
    }
  },
  beforeMount() {
    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'all_lapsed_clients' && ($event.type === 'store' || $event.type === 'update')) {
        this.get_companies();
      }
    });

    // unified base columns (no extras)
    this.columns = [
      {headerName: 'Name', field: 'company_name', minWidth: 200, pinned: 'left'},
      {headerName: 'Type', field: 'company_type', minWidth: 120, pinned: 'left'},
      {headerName: 'V3 Client', field: 'v3_client', minWidth: 80},
      {headerName: 'Lead Status', field: 'lead_status', minWidth: 120},
      {headerName: 'Pipeline Status', field: 'pipeline_status', minWidth: 160},
      {headerName: 'Pipeline Opportunity Size', field: 'pipeline_opportunity_size', minWidth: 160},
      {headerName: 'Weekly Deal Value', field: 'deal_value', minWidth: 140},
      {headerName: 'Consultant', field: 'primary_consultant_name', minWidth: 175},
      {headerName: 'City', field: 'city_town', minWidth: 160},
      {headerName: 'County', field: 'county', minWidth: 160},
      {headerName: 'Internal Ref', field: 'internal_finance_ref', minWidth: 140},
      {headerName: 'External Ref', field: 'external_finance_ref', minWidth: 140},
    ];

    // payroll tweak
    if (this.crmType === 'payroll') {
      let [name, type, ...rest] = this.columns;
      this.columns = [name, type, {headerName: 'V3 Client', field: 'v3_client', minWidth: 40}, ...rest];
    }
  },
  mounted() {
    this.get_companies();
  },
  beforeDestroy() {
    this.companies = null;
  },
  methods: {
    get_companies() {
      axios.get(`${this.crmApiPath}sunset/companies/lapsed`).then(companies => this.companies = companies.data).catch(error => console.log(error.response));
    }
  },
}
</script>
